import { render, staticRenderFns } from "./Jugadores.vue?vue&type=template&id=5b77bb04&scoped=true"
import script from "./Jugadores.vue?vue&type=script&lang=js"
export * from "./Jugadores.vue?vue&type=script&lang=js"
import style0 from "./Jugadores.vue?vue&type=style&index=0&id=5b77bb04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77bb04",
  null
  
)

export default component.exports